import styled, { css } from 'styled-components'
import { Typography } from '@material-ui/core'

export const ProgramName = styled(Typography)(
  ({ theme }) => css`
    text-transform: uppercase;
    font-weight: ${theme.typography.fontWeightBold};
  `
)
